import type { SearchSubmittedEvent } from 'features/knowledgeDocumentViewer/components/advancedSearch/contexts/AdvancedSearchUXContext'
import { useDocumentSearchData } from 'features/knowledgeDocumentViewer/components/advancedSearch/contexts/DocumentSearchDataContext'
import { useCallback } from 'react'

export function useDocumentSearchSubmitRefresh(): (
  event: SearchSubmittedEvent
) => void {
  const { refreshDocumentSearch } = useDocumentSearchData()

  return useCallback(
    ({
      query,
      options,
      previousSearchState,
      isLinkedDocsMode,
    }: SearchSubmittedEvent) => {
      if (options?.startDocChatTurn === true) return
      if (query.length === 0) return
      if (query !== previousSearchState.query.trim()) return
      if (previousSearchState.contentFilter !== 'documents') return
      if (previousSearchState.browseAll === true) return
      if (isLinkedDocsMode) return

      refreshDocumentSearch()
    },
    [refreshDocumentSearch]
  )
}
